import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Lock, RefreshCw } from 'lucide-react';
const reviews = [{
  text: 'Mi hija ahora practica sola porque siente que está jugando.',
  author: 'Mariana G.',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
}, {
  text: 'Las actividades son claras y muy entretenidas.',
  author: 'Laura P.',
  avatar: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
}, {
  text: 'Lo usamos tanto en casa como en el aula.',
  author: 'Daniela R.',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
}, {
  text: 'Mi hijo mejoró muchísimo su escritura.',
  author: 'Sofía M.',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
}, {
  text: 'Vale cada peso invertido.',
  author: 'Paula C.',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
}, {
  text: 'Mucho más completo de lo que esperaba.',
  author: 'Romina T.',
  avatar: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80'
}];
export function SocialProofSection() {
  return <>
      {/* SECTION 7: VERIFIED REVIEWS */}
      <section className="py-24 bg-brand-lilac/10" data-id="element-214">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-216">
            <h2 className="text-3xl md:text-4xl font-extrabold text-brand-dark mb-4" data-id="element-217">
              Lo que dicen otras familias
            </h2>
            <div className="flex justify-center gap-1 mb-4" data-id="element-218">
              {[...Array(5)].map((_, i) => <Star key={i} className="text-brand-yellow" size={24} fill="currentColor" data-id="element-219" />)}
            </div>
            <p className="text-lg text-brand-text font-medium" data-id="element-220">
              Más de 5.000 mamás y docentes ya confían en nuestro método.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-221">
            {reviews.map((review, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col justify-between" data-id="element-222">
                <div data-id="element-223">
                  <div className="flex gap-1 mb-4" data-id="element-224">
                    {[...Array(5)].map((_, i) => <Star key={i} className="text-brand-yellow" size={16} fill="currentColor" data-id="element-225" />)}
                  </div>
                  <p className="text-brand-dark font-medium text-lg italic mb-6" data-id="element-226">
                    "{review.text}"
                  </p>
                </div>
                <div className="flex items-center gap-3" data-id="element-227">
                  <img src={review.avatar} alt={review.author} className="w-12 h-12 rounded-full object-cover border-2 border-brand-lilac" data-id="element-228" />
                  <div data-id="element-229">
                    <p className="font-bold text-brand-dark" data-id="element-230">{review.author}</p>
                    <p className="text-xs text-green-600 font-semibold flex items-center gap-1" data-id="element-231">
                      <ShieldCheck size={12} data-id="element-232" /> Compra verificada
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* SECTION 8: BUY WITH CONFIDENCE */}
      <section className="py-16 bg-brand-dark text-white" data-id="element-233">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-234">
          <h2 className="text-3xl font-extrabold mb-6 text-white" data-id="element-235">
            Compra con tranquilidad
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-236">
            Acceso inmediato al material digital y actualizaciones futuras del
            contenido.
          </p>

          <div className="grid sm:grid-cols-3 gap-8" data-id="element-237">
            <div className="flex flex-col items-center gap-3" data-id="element-238">
              <div className="bg-white/10 p-4 rounded-full" data-id="element-239">
                <Lock size={32} className="text-brand-mint" data-id="element-240" />
              </div>
              <h3 className="font-bold text-lg" data-id="element-241">Pago 100% Seguro</h3>
              <p className="text-sm text-slate-400" data-id="element-242">
                Tus datos están protegidos
              </p>
            </div>
            <div className="flex flex-col items-center gap-3" data-id="element-243">
              <div className="bg-white/10 p-4 rounded-full" data-id="element-244">
                <RefreshCw size={32} className="text-brand-blue" data-id="element-245" />
              </div>
              <h3 className="font-bold text-lg" data-id="element-246">Acceso Inmediato</h3>
              <p className="text-sm text-slate-400" data-id="element-247">
                Recibís todo por email al instante
              </p>
            </div>
            <div className="flex flex-col items-center gap-3" data-id="element-248">
              <div className="bg-white/10 p-4 rounded-full" data-id="element-249">
                <ShieldCheck size={32} className="text-brand-yellow" data-id="element-250" />
              </div>
              <h3 className="font-bold text-lg" data-id="element-251">Garantía de Satisfacción</h3>
              <p className="text-sm text-slate-400" data-id="element-252">7 días de garantía</p>
            </div>
          </div>
        </div>
      </section>
    </>;
}